import api from './api'

export const authAPI = {
  // Login user
  login: (credentials) => api.post('/auth/login', credentials),
  
  // Register user
  register: (userData) => api.post('/auth/register', userData),
  
  // Get current user
  getCurrentUser: () => api.get('/auth/me'),
  
  // Logout user
  logout: () => api.post('/auth/logout'),
  
  // Refresh token
  refreshToken: () => api.post('/auth/refresh-token'),
  
  // Forgot password
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  
  // Reset password
  resetPassword: (token, password) => api.post('/auth/reset-password', { token, password }),
  
  // Change password
  changePassword: (currentPassword, newPassword) => api.post('/auth/change-password', { 
    currentPassword, 
    newPassword 
  }),
  
  // Check SSO availability for email
  checkSSO: (email) => api.post('/auth/check-sso', { email }),
  
  // Lookup tenant for email
  lookupTenant: (email) => api.post('/auth/lookup-tenant', { email }),
  
  // Complete login after MFA verification
  completeLogin: (sessionToken) => api.post('/auth/complete-login', { session_token: sessionToken })
}



